// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.login-popup-container {
  position: relative;
  width: 100%;
  max-width: 450px;
  background: white;
  border-radius: 15px;
  padding: 40px 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.login-close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(240, 240, 240, 0.8);
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  z-index: 10;
}

.login-close-button:hover {
  background: #f0f0f0;
  transform: scale(1.1);
}

.login-popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.login-popup-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.login-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  margin-bottom: 25px;
}

.login-option-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 14px 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: white;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-option-button:hover:not(.disabled) {
  background-color: #f8f8f8;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.login-option-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.login-option-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.login-terms {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.5;
  max-width: 90%;
}

.login-terms-link {
  color: #4285f4;
  text-decoration: none;
  font-weight: 500;
}

.login-terms-link:hover {
  text-decoration: underline;
}

/* Responsive styles */
@media (max-width: 576px) {
  .login-popup-container {
    max-width: 75%;
    padding: 30px 20px;
  }
  
  .login-popup-title {
    font-size: 24px;
    margin-bottom: 25px;
  }
  
  .login-option-button {
    padding: 12px 16px;
    font-size: 15px;
  }
  
  .login-terms {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Popup/LoginPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n}\n\n.login-popup-container {\n  position: relative;\n  width: 100%;\n  max-width: 450px;\n  background: white;\n  border-radius: 15px;\n  padding: 40px 30px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.login-close-button {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: rgba(240, 240, 240, 0.8);\n  border: none;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  z-index: 10;\n}\n\n.login-close-button:hover {\n  background: #f0f0f0;\n  transform: scale(1.1);\n}\n\n.login-popup-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.login-popup-title {\n  font-size: 28px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.login-options {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n.login-option-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 14px 20px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  background-color: white;\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.login-option-button:hover:not(.disabled) {\n  background-color: #f8f8f8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.login-option-button.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #f5f5f5;\n}\n\n.login-option-icon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.login-terms {\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n  line-height: 1.5;\n  max-width: 90%;\n}\n\n.login-terms-link {\n  color: #4285f4;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.login-terms-link:hover {\n  text-decoration: underline;\n}\n\n/* Responsive styles */\n@media (max-width: 576px) {\n  .login-popup-container {\n    max-width: 75%;\n    padding: 30px 20px;\n  }\n  \n  .login-popup-title {\n    font-size: 24px;\n    margin-bottom: 25px;\n  }\n  \n  .login-option-button {\n    padding: 12px 16px;\n    font-size: 15px;\n  }\n  \n  .login-terms {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
